export class InputWidthEnum {
    static SM = 'sm'
    static MD = 'md'
    static LG = 'lg'
    static XL = 'xl'
    static FULL = 'full'
}